// src/modules/app-views/_apps/applekkus/landingPages/seed.js
// *******************************************************************************
// SEED
// *******************************************************************************

// No module parameters needed for now
const seedLandingPagesParameters = null;

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedLandingPagesParameters;
